export const LegendItem = ({ colour, label }) => {
  const blockStyle = { width: 10, height: 10, backgroundColor: colour };
  const containerStyle = {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    gap: 10,
  };
  const labelStyle = {};
  return (
    <div style={containerStyle}>
      <div style={blockStyle} />
      <div style={labelStyle}>{label}</div>
    </div>
  );
};
